import clsx from "clsx";
import { FC, HTMLInputTypeAttribute } from "react";

interface Props {
  label?: string;
  cornerHint?: string;
  helpText?: string;
  placeholder?: string;
  id?: string;
  name?: string;
  type?: HTMLInputTypeAttribute;
  value?: string;
  disabled?: boolean;
  onChange?: (item: string) => void;
  error?: string;
  touched?: boolean;
}

const Input: FC<Props> = ({
  label,
  cornerHint,
  helpText,
  placeholder,
  id,
  name,
  type = "text",
  value,
  disabled,
  onChange,
  error,
  touched,
}) => {
  return (
    <div>
      <div className="tw-flex tw-justify-between">
        {label && (
          <label
            htmlFor={name}
            className={clsx(
              "tw-block tw-text-sm tw-font-medium",
              error && touched ? "tw-text-red-500" : "tw-text-gray-700"
            )}
          >
            {label}
          </label>
        )}
        {cornerHint && <span className="tw-text-sm tw-text-gray-500">Optional</span>}
      </div>
      <div className="tw-mt-1">
        <input
          type={type}
          name={name}
          id={id}
          className={clsx(
            "tw-shadow-sm focus:tw-ring-indigo-500 focus:tw-border-indigo-500 tw-block tw-w-full sm:tw-text-sm  tw-rounded-md disabled:tw-bg-gray-100 disabled:tw-cursor-not-allowed",
            error && touched? "tw-border-red-500" : "tw-border-gray-300"
          )}
          placeholder={placeholder}
          value={value}
          disabled={disabled}
          onChange={(e) => onChange && onChange(e.target.value)}
        />
      </div>
      {helpText && (!error || !touched) && (
        <p className="tw-mt-2 tw-text-xs tw-text-gray-500">{helpText}</p>
      )}
      {error && touched && <p className="tw-mt-2 tw-text-xs tw-text-red-500">{error}</p>}
    </div>
  );
};

export default Input;
